export const FLOVATAR_MP_FOR_SALE =
  "A.921ea449dffec68a.FlovatarMarketplace.FlovatarComponentForSale";

export const FLOVATAR_MP_SALE_WITHDRAW =
  "A.921ea449dffec68a.FlovatarMarketplace.FlovatarComponentSaleWithdrawn";
